import { useNavigate } from 'react-router-dom'

import { Headline } from '@components/designSystem/Headline'
import StoreSelection from '@routes/StoreSelection/StoreSelection'
import { routesFactory } from '@utils/routes.ts'

function StoreSelectionRoute() {
  const navigate = useNavigate()

  return (
    <div className='flex flex-col items-center gap-4 px-4 pt-16'>
      <Headline i18nKey='storeSelection.selectStore.title' />

      <div className='w-full md:w-md'>
        <StoreSelection
          mode='button'
          onStorePress={(storeId) => navigate(routesFactory.home(storeId))}
        />
      </div>
    </div>
  )
}

export default StoreSelectionRoute